module.exports = __webpack_public_path__ + "static/turbine-97e802f84db04c1712c6932cf9bc9b8b.mp4";